import { render, staticRenderFns } from "./boxDevice.vue?vue&type=template&id=2657216a"
import script from "./boxDevice.vue?vue&type=script&lang=js"
export * from "./boxDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports